




import {Component, Vue} from 'vue-property-decorator';
import ChangePasswordForm from "@/components/Molecules/ChangePasswordForm/ChangePasswordForm.vue";
import {ChangePasswordFormType, ResetPasswordFormDto} from "@/share";
import {ServiceFactory} from "@/services";

const AuthService = ServiceFactory.get('auth');

@Component({
  components: {
    ChangePasswordForm
  }
})

export default class ChangePassword extends Vue {
  private error = ''
  private isLoading = false

  private async changePassword(formData: ChangePasswordFormType): Promise<any> {
    const {password, passwordConfirmation, token} = formData
    const data: ResetPasswordFormDto = new ResetPasswordFormDto({
      password: password || '',
      passwordConfirmation: passwordConfirmation || '',
      token: token || '',
    })

    this.error = ''
    this.isLoading = true
    let response = await AuthService.resetPassword(data).catch(() => ({}))
    this.isLoading = false

    if (response.hasError) return this.error = response.message

    return this.$router.push({name: 'routes.auth.login'})
  }
}
